import React from 'react'

export default function LandingPageBlockForVideo() {
  return (
<>
<img src="https://all-frontend-assets.s3.amazonaws.com/aspireLeadFire/landingpage6/land6_vidblockimg.webp" alt="" className='preimg'/>
</>  
)
}
